import {Component, OnInit, Input, EventEmitter, Output} from '@angular/core';
import {FormGroup, FormBuilder, Validators, AbstractControl, FormControl} from "@angular/forms";
import {PsusService} from "../shared/model/psus.service";
import {isoDate} from "../shared/util/date-util";
import {DEFAULT_POWER, OVERBOOST, DEFAULT_POWER_SCALAR, DEFAULT_POWER_ON_VALUE, DRIVERS} from "../shared/model/psu";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-psu-add',
    templateUrl: './psu-add.component.html',
    styleUrls: ['./psu-add.component.css']
})
export class PsuAddComponent implements OnInit {

    @Input()
    dbPath: string;     // link to Firebase database path location (<dbLocation>/fields/clubId/fieldId/cpus/cpuId)

    @Output()
    onAddDone = new EventEmitter<boolean>();

    myForm: FormGroup;

    psuId: number = 0;
    description: string = ""; // firmware version of the PSU
    defaultPower: number = DEFAULT_POWER;  // default maximum wattage = 80%
    power: number = DEFAULT_POWER;
    overboost: number = OVERBOOST;  // absolute maximum power
    powerConsumption: number = 0;
    installationDate: string = isoDate();
    soll: number = 0;
    ist: number = 0;
    serialNr: string = "";
    burnTime: number = 0;
    outVoltage12: number = 0;
    outVoltage34: number = 0;
    current: number = 0;
    inputVoltage: number = 0;
    powerOnValue: number = DEFAULT_POWER_ON_VALUE;

    isSaved: boolean = false;
    hasError: boolean = false;
    message: string = "";

    drivers = DRIVERS;
    driverValue = "V2, 1.0 kW";
    labels = [];

    public visibleAdd = true;
    public visibleAddAnimate = false;

    constructor(private fb: FormBuilder, private psusService: PsusService, private translate: TranslateService) {
        this.myForm = fb.group({
          'psuId': ['', Validators.compose([Validators.required, Validators.pattern("^(?:[0-9]|1[0-9])$")])],
          'defaultPower': ['', Validators.compose([Validators.required])],
          'overboost': ['', Validators.compose([Validators.required])],
          'powerOnValue': ['', Validators.compose([])],
          'installationDate': ['', Validators.compose([Validators.required, Validators.minLength(6)])]
        });
    }

    formDone(done: boolean) {
        //console.log("addPsu: formDone() pressed: " + done);
        this.onAddDone.emit(false);  // hide modal add screen
    }

    ngOnInit() {
      this.translate.get('l.unknown')
        .subscribe((res: string) => {
          this.description = res;
          this.serialNr = res;
          this.show();
        });
      this.setLabels();
      this.setDriverType( 'V2, 1.0 kW');
    }

    public show(): void {
        this.visibleAdd = true;
        setTimeout(() => this.visibleAddAnimate = true);
    }

    public hide(): void {
        this.visibleAddAnimate = false;
        setTimeout(() => this.visibleAdd = false, 300);
    }

    public save() {
      this.psusService.addPsu(this.psuId, this.dbPath, this.description, this.defaultPower, this.power, this.overboost, this.installationDate,
        this.soll, this.ist, this.serialNr, this.burnTime, this.powerConsumption, this.outVoltage12, this.outVoltage34, this.current, this.inputVoltage, this.powerOnValue );

      this.translate.get('s.spawn')
        .subscribe((res: string) => {
          this.message = res;
          this.isSaved = true;
        });
    }

    public setLabels() {
      for ( let d in Object.keys(this.drivers) ) {
        this.labels.push( this.drivers[ d ]['label'] );
      }
    }

  public setDriverType( t: string ) {
    this.driverValue = t;
    for ( let i = 0; i < Object.keys(this.drivers).length; i++ ) {
      if ( this.drivers[i]['label'] === t ) {
        this.overboost = this.drivers[i].overboost;
        this.defaultPower = this.drivers[i].default;
        if ( t.indexOf('V2') !== -1 ) {
          this.powerOnValue = this.drivers[i].powerOnValue;
          this.description = '1.x / 0.x';   // UI will show more items for 1.x (=V2)
        } else if ( t.indexOf('Relay') !== -1 ) {
          this.psuId = 1;
          this.description = 'RS485 Relay';
          this.powerOnValue = -1; // Relay doesn't have a power on value
        } else {
          this.powerOnValue = -1; // V1 doesn't have a power on value
          this.description = '0.x / 0.x';
        }
      }
    }
  }

}
